import { memo } from 'react'
import { useSelector } from '@tabeeb/store'

import { useDialogState } from '@tabeeb/shared/utils/hooks'

import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import ManageUsersDialog from '@tabeeb/modules/invites/components/ManageUsersDialog'
import { getHasInvitePermission } from '@tabeeb/modules/permissions/selectors'
import { PersonAdd } from '@mui/icons-material'
import { StyledInviteButton } from './styles'

const InviteButton = () => {
  const [open, onOpen, onClose] = useDialogState()

  const canInviteUsers = useSelector(getHasInvitePermission)

  if (!canInviteUsers) {
    return null
  }

  // TODO: Bring back new icon when DJ is ready
  return (
    <>
      <StyledInviteButton title='Manage users' onClick={onOpen}>
        {/* <ManageAccountsIcon /> */}
        <PersonAdd />
      </StyledInviteButton>
      <ManageUsersDialog open={open} onClose={onClose} />
    </>
  )
}

export default memo(InviteButton)

